import React from 'react'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
import { withModal } from '@brainstud/react-tbl/features/modals'

import Default from './Default'
import NoTemplate from './NoTemplate'

const introTypes = {
  default: Default,
}

export default props => {
  const IntroType = introTypes[props.type || 'default']
  return <IntroType {...props} />
}

const Template = props => {
  const Chapter = props.app.templates.chapters[props.chapter.id]
  if(!Chapter) return <NoTemplate {...props} />

  const Intro = Chapter['intro']
  if(!Intro) return <NoTemplate {...props} />

  return <Intro {...props} />
}

export const CurrentTemplate = withApp(withModal(Template))
